@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!--#region Label Top -->

  @if (label() && settings().labelPosition === 'top' && settings().showLabel) {
    <ng-container *ngTemplateOutlet="uiLabelTemplateRef"></ng-container>
  }
  <ng-content select="label[slot-top]"></ng-content>

  <!--#endregion Label Top -->

  <div uiinputcontent [class]="contentCssClass()">
    <!--#region Input -->

    <input
      #uiValueRef
      type="file"
      (change)="canEdit ? onFileSelected($event) : false"
      [multiple]="allowMultipleFiles()"
      [hidden]="true"
      [accept]="allowedFileTypes()"
    />
    <btn
      uiunpermissioned
      [class]="buttonCssClass()"
      [settings]="{
        label: 'Upload',
        iconOnly: !settings().showLabel,
        disabled: isUploading() || !canEdit,
      }"
      (click)="uiValueRef.click()"
    >
      <icon
        [class.animate-spin]="isUploading()"
        slot-left
        [iconDefinition]="
          isUploading() ? ICONS.PROGRESS : settings().defaultIcon
        "
        [iconSize]="'icon-size-[0.875rem]'"
      ></icon>
    </btn>

    <!--#endregion Input -->

    <!--#region Footer -->

    @if (settings().showFooter) {
      <span uifooter>
        {{
          value() && isUploading()
            ? `Uploading ${value()}...`
            : 'No file chosen.'
        }}
      </span>
    }

    <!--#endregion Footer-->
  </div>

  <!--#region Templates -->

  <!-- Label Template -->
  <ng-template #uiLabelTemplateRef>
    <label
      [class.hidden]="!settings().label && !settings().labelTip"
      [attr.slot-embedded]="
        settings().labelPosition === 'embedded' ? true : undefined
      "
      [label]="labelFormatted()"
      [labelTip]="labelTip()"
      [state]="state()"
    >
    </label>
  </ng-template>

  <!--#endregion Templates -->
}
